import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';

export const StepWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  width: 100%;
  text-align: left;

  & > :first-child {
    padding-right: ${({ theme }) => theme.spacing.unit * 1.5}px;
  }
`;

export const BadgeContainer = styled.div`
  display: none;

  ${media.sm`
        display: flex;

        & > div {
            height: fit-content;
            width: 100px;
            padding: 4px 0;
        }
    `}
`;
